import axios from "axios";
import { API_URL } from "./axioscontants";
const instance = axios.create({

    baseURL: API_URL,
    // timeout: 5000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    withCredentials: true,
});

export default instance;
